var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('am-autocomplete',_vm._b({attrs:{"label":_vm.label,"placeholder":_vm.label,"options":_vm.options},on:{"model":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'am-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }